import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementVNode as _createElementVNode, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "main-content" };
const _hoisted_2 = {
    "no-gutters": "",
    class: "my-4 d-flex align-center justify-end"
};
import { reactive, ref, } from 'vue';
import { makeComponentInfoList } from '@/utils';
import { createHubFormRules, isValidKilometerProductRange, } from '@/form/form-rules/hubManangement';
import { routeName } from '@/constants/routeName';
import { createHubManagementFormData as createFormData } from '@/form/form-data';
import { i18n } from '@/locales';
import { errorCode } from '@/error';
import CardSection from '@/components/Common/CardSection.vue';
import { useRouter } from 'vue-router';
import { alertActionType } from '@/vuex-store/alert/actions';
import { snackbarActionType } from '@/vuex-store/snackbar/actions';
import { objDeepCompare } from '@/utils/object';
import vuexStore from '@/vuex-store';
import HubCreateBasicInfo from './BasicInfo.vue';
import HubCreateWorkerOperationInfo from './WorkerOperationSetting.vue';
import HubCreateAdjustmentOperationInfo from './AdjustmentOperationSetting.vue';
const lc = 'views.hub_management.';
const formRulesLc = 'form_rules.';
export default /*@__PURE__*/ _defineComponent({
    __name: 'index',
    setup(__props) {
        const comp = {
            HubCreateBasicInfo,
            HubCreateWorkerOperationInfo,
            HubCreateAdjustmentOperationInfo,
        };
        const getComp = (n) => comp[n];
        const router = useRouter();
        const hubCreateCardComponents = [
            makeComponentInfoList('HubCreateBasicInfo', i18n.t(`${lc}basic_info`)),
            makeComponentInfoList('HubCreateWorkerOperationInfo', i18n.t(`${lc}worker_operation_setting`)),
            makeComponentInfoList('HubCreateAdjustmentOperationInfo', i18n.t(`${lc}adjustment_operation_setting`)),
        ];
        const formRules = createHubFormRules(formRulesLc);
        const formRef = ref(null);
        const createdFormData = createFormData();
        const createdOriginFormData = createFormData();
        const formData = reactive(createdFormData);
        const originFormData = reactive(createdOriginFormData);
        const createErrorMessageData = () => ({
            masterIdExistence: '',
            hubRepresentativePhoneExistence: '',
            isSameIdAndPassword: '',
        });
        const initErrorMessageData = createErrorMessageData();
        const errorMessageData = reactive(initErrorMessageData);
        const postHub = (payload) => vuexStore.dispatch('hubManagement/hubCreate/postHub', payload);
        const showSuccess = (payload) => vuexStore.dispatch(snackbarActionType.showSuccess, payload);
        const showError = (payload) => vuexStore.dispatch(snackbarActionType.showError, payload);
        const confirm = (payload) => vuexStore.dispatch(alertActionType.confirm, payload);
        const isFormValid = (errorMessages) => {
            const messageList = [
                i18n.t('common.form_validation_error'),
            ];
            const isValidData = formRef.value?.validate() && !!formData.addressFormData._siDo;
            const isErrorMessageExist = Object.values(errorMessages).some((message) => !!message);
            const isValidKilometerRange = isValidKilometerProductRange(formData.hubConfiguration.minimumKilometerProduct, formData.hubConfiguration.kilometerProduct);
            if (isValidData && isValidKilometerRange && !isErrorMessageExist) {
                return true;
            }
            if (!isValidKilometerRange) {
                const notValidRangeErrorMessage = i18n.t('form_rules.end_value_greater_than_start', {
                    endField: i18n.t(`${lc}hub_configuration.kilometer_product`),
                    startField: i18n.t(`${lc}hub_configuration.minimum_kilometer_product`),
                });
                messageList.unshift(notValidRangeErrorMessage);
            }
            showError({
                message: messageList,
            });
            return false;
        };
        const goToMainPage = () => {
            router.push({
                name: routeName.HUB_MANAGEMENT,
            });
        };
        const _onSubmit = async (submitData) => {
            try {
                const response = await postHub(submitData);
                if (!response.isSuccess) {
                    if (response.reason || response.message) {
                        return showError({
                            message: errorCode[response.reason] ?? response.message,
                        });
                    }
                    return showError({
                        message: i18n.t('common.unknown_error'),
                    });
                }
                goToMainPage();
                return showSuccess({
                    message: i18n.t(`${lc}create_hub_info_success`),
                });
            }
            catch (error) {
                console.log('hubManagement/hubCreate/index/_onSubmit', error);
                return showError({
                    message: i18n.t('common.failure'),
                });
            }
        };
        const handleSubmitForm = () => {
            const isValid = isFormValid(errorMessageData);
            if (!isValid) {
                return;
            }
            _onSubmit(formData);
        };
        const handleClickCancelForm = async () => {
            const isSameData = objDeepCompare(originFormData, formData);
            if (isSameData) {
                goToMainPage();
                return;
            }
            const isConfirmOk = await confirm({
                headerTitle: `${i18n.t(`${lc}registration`)} ${i18n.t('common.cancel')}`,
                bodyContent: i18n.t('common.confirm_before_cancel'),
                btnConfig: [
                    {
                        text: 'cancel',
                        cssClass: 'outlined info',
                    },
                    {
                        text: 'ok',
                        cssClass: 'danger',
                    },
                ],
            });
            if (isConfirmOk) {
                goToMainPage();
            }
        };
        return (_ctx, _cache) => {
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_form = _resolveComponent("v-form");
            const _directive_btn_style = _resolveDirective("btn-style");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_v_form, {
                    ref_key: "formRef",
                    ref: formRef,
                    class: "create-hub-wrapper",
                    onSubmit: _withModifiers(handleSubmitForm, ["prevent"])
                }, {
                    default: _withCtx(() => [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(hubCreateCardComponents, ({ componentName, title }, key) => {
                            return _createVNode(CardSection, {
                                key: key,
                                title: title
                            }, {
                                default: _withCtx(() => [
                                    (_openBlock(), _createBlock(_resolveDynamicComponent(getComp(componentName)), {
                                        "form-data": formData,
                                        "form-rules": _unref(formRules),
                                        lc: lc,
                                        "form-rules-lc": formRulesLc,
                                        "error-message-data": errorMessageData
                                    }, null, 8 /* PROPS */, ["form-data", "form-rules", "error-message-data"]))
                                ]),
                                _: 2 /* DYNAMIC */
                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["title"]);
                        }), 64 /* STABLE_FRAGMENT */)),
                        _createElementVNode("div", _hoisted_2, [
                            _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                                class: "mr-2",
                                onClick: handleClickCancelForm
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(i18n).t('common.cancel')), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                            })), [
                                [
                                    _directive_btn_style,
                                    void 0,
                                    "config",
                                    {
                                        info: true,
                                        outlined: true,
                                        "width-xs": true,
                                        "size-l": true
                                    }
                                ]
                            ]),
                            _withDirectives((_openBlock(), _createBlock(_component_v_btn, { type: "submit" }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(i18n).t('common.register')), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                            })), [
                                [
                                    _directive_btn_style,
                                    void 0,
                                    "config",
                                    {
                                        primary: true,
                                        "width-xs": true,
                                        "size-l": true
                                    }
                                ]
                            ])
                        ])
                    ]),
                    _: 1 /* STABLE */
                }, 512 /* NEED_PATCH */)
            ]));
        };
    }
});
